import { mapActions } from "vuex";

export default  {
	created () {    
	},
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'garantiaOrdenFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'garantia_orden',
									tablaPost: ['garantia_diagnosticos','garantia_orden'],
								 }
							 }) 
						break;
						case 'recibirGarantiaFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'garantia_recibido', 
									tablaPost: ['garantia_orden']
								 }
							 })
						break;
						case 'entregaFtn':
							
							await this.updateDataForm({state: 'garantia_orden/estado', data: 'entregado'})
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'garantia_entrega', 
									tablaPost: ['garantia_orden']
								 }
							 })
						break;

					}
				}

				let data_backend= await this.save(event.save)

				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'garantiaOrdenFtn':
							window.open(this.url+"/api/pdf/garantia_orden_venta?id="+data_backend['ids']['id_garantia_orden']+"&token="+this.token, "_blank");						
							window.open(this.url+"/api/pdf/garantia_diagnosticos?id="+data_backend['ids']['id_garantia_orden']+"&token="+this.token, "_blank")

							await this.updateDataGet({ index: this.indexData, state: 'garantia_orden', data: this.dataForm[this.namePath].garantia_orden})
							await this.updateDataGet({ index: this.indexData, state: 'garantia_diagnosticos', data: this.dataForm[this.namePath].garantia_diagnosticos})						
						break;
						case 'recibirGarantiaFtn':
							this.updateDataGet({state: 'garantia_orden',index: this.indexData, data: this.dataForm[this.namePath].garantia_orden})						
						break;
						case 'entregaFtn':
							this.spliceDataGet(this.indexData)						
						break;
					}
				}
				
				await this.resetGlobal({state: 'indexData'}) 								
				await this.resetGlobal({state: 'openModal'}) 
				await this.resetDataForm()
				
				return true
			}
			catch{

			}			
		}		
	},
}
